<script setup>
import { useGlobalStore } from '@stores/global'
import { useEventStore } from '@stores/event'
import EventCard from '@components/global/EventCard.vue'
import Button from '@components/forms/Button.vue'

const global = useGlobalStore()
const store = useEventStore()
</script>

<template>
	<section class="bg-gradient-to-bl from-logi-grey-600 via-black to-black py-10 md:py-14 lg:py-20">
		<div class="container">
			<div class="flex flex-col gap-5 md:gap-10 lg:gap-14">
				<div class="flex flex-col gap-3">
					<h3>All Events</h3>
					<p class="text-white/70">Check out our latest community events and join in on the action.</p>
				</div>
				<div class="grid grid-cols-1 gap-5 md:grid-cols-2 xl:grid-cols-3">
					<EventCard v-for="event in store.events" :key="event.slug" :to="{ name: 'event', params: { slug: event.slug } }" :event="event" />
				</div>
				<!-- <div class="flex justify-center">
					<Button class="primary solid" icon="fa-solid fa-arrow-down">Load More</Button>
				</div> -->
			</div>
		</div>
	</section>
</template>
